import './assets/playMarketSKAK/css/main.css';
import { FormEvent, useState } from 'react';
import { createGetLocale } from '@pwlaunch/pwa-sdk/config';
import { storePd, useAppContent, useInstallerContext } from '@pwlaunch/pwa-sdk';
import { RenderDescription } from '@pwlaunch/pwa-google-play-v1/src/playMarket/components/renderDescription.tsx';

const getLocale = createGetLocale<'playMarketSKAK'>();

function withImageUrl(id: string) {
	return `/images/${id}`;
}

function SimilarApps({ position }: { position: string }) {
	const config = useAppContent<'playMarketSKAK'>();
	const dataMap = config.dataMap;

	const relatedApps = dataMap?.locale?.relatedApps || {};

	if (!relatedApps.enabled) {
		return null;
	}

	if (position !== relatedApps.position) return null;

	const apps = relatedApps?.apps || [];

	const items = new Array(12).fill(null).map((_, index) => {
		return apps[index % apps.length];
	})!;

	return (
		<>
			<div className="blockInfo_wrap__dXLoU">
				<div className="blockInfo_titleWrap__3mSIz">
					<div className="blockInfo_title__aiyrK">{getLocale('playMarketSKAK:similarGames')}</div>
					<div className="blockInfo_icon__m5Gvc">
						<svg height="24" viewBox="0 0 24 24" width="24">
							<path d="M0 0h24v24H0z" fill="none" />
							<path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
						</svg>
					</div>
				</div>
				<div className="blockInfo_body__WnTfr   " />
			</div>
			<div className="similarGames_wrap__es2sI">
				<div className="similarGames_scrollCon__KSKC4">
					{items.map((app, index) => (
						<div className="similarGames_item__ufz12" key={index}>
							<div className="similarGames_icon__Qr2gM">
								<picture>
									<img alt="icon" src={withImageUrl(app?.icon || '')} />
								</picture>
							</div>
							<div className="similarGames_title__YlFsW">{app?.name}</div>
							<div className="similarGames_rating__87n5L">
								{app?.rating}{' '}
								<svg height="32" viewBox="0 0 96 96" width="32">
									<path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
								</svg>
							</div>
						</div>
					))}
				</div>
			</div>
		</>
	);
}

function Reviews() {
	const config = useAppContent<'playMarketSKAK'>();
	const dataMap = config.dataMap;

	const reviews = dataMap?.locale?.reviews || [];

	return (
		<div className="ratingReview_wrapCom__EkEd5">
			{reviews.map((review, index) => (
				<div className="commentItem_wrap__DArc+" key={index}>
					<div className="commentItem_top__s89jN">
						<div className="commentItem_avatarW__VD4J5">
							<div>
								<picture>
									<img alt="auth" src={withImageUrl(review?.avatar || '')} />
								</picture>
							</div>
							<div className="commentItem_name__MQa35">{review?.name}</div>
						</div>
						<div className="commentItem_btn__gSBG3">
							<svg height="24" viewBox="0 0 24 24" width="24">
								<path d="M0 0h24v24H0z" fill="none" />
								<path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
							</svg>
						</div>
					</div>
					<div className="commentItem_rating__9oY6q">
						<div className="starRating_starList__OXpkk">
							{new Array(5).fill(null).map((_e, i) => (
								<div
									key={i}
									className={`starRating_starItem__4y0tg ${i + 1 <= (review?.rating || 5) ? 'starRating_starItemFill__35ABL' : `starRating_starItemNotFill__Bue`}`}
									style={{
										height: '12px',
										width: '12px',
									}}
								>
									<svg height="32" viewBox="0 0 96 96" width="32">
										<path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
									</svg>
								</div>
							))}
						</div>
						<span className="commentItem_date__Jtmov">{review?.commentDate}</span>
					</div>
					<div className="commentItem_comment__zKpWK commentItem_min__W+Eh+">{review?.text}</div>
					<div className="commentItem_like__CzGaH">
						{getLocale('playMarketSKAK:reviews:rating').replace('{{amount}}', review?.reviewRating)}
					</div>
					<div className="commentItem_wasRev__1f58E">
						<div className="commentItem_text__o46jf">{getLocale('playMarketSKAK:reviews:isHelpful')}</div>
						<div className="commentItem_btn__gSBG3">
							<div className="commentItem_btnItem__14Ant">{getLocale('playMarketSKAK:Yes')}</div>
							<div className="commentItem_btnItem__14Ant">{getLocale('playMarketSKAK:No')}</div>
						</div>
					</div>
					{review?.showOwnerResponse && review?.ownerResponse ?
						<div className="content_comments_resWrapper__NuvTU">
							<div className="content_comments_resTop__zTCTx">
								<div className="content_comments_resAuth__RZ6JW">{dataMap.locale?.owner}</div>
								<div className="content_comments_resDate__vhI07">{review?.ownerResponseDate}</div>
							</div>
							<div className="content_comments_resComm__jaZuR">
								<div>{review.ownerResponse}</div>
							</div>
						</div>
					:	null}
				</div>
			))}
			{/*<div className="ratingReview_more__mNU+1">Все отзывы</div>*/}
		</div>
	);
}

function ContactsModal({ next }: { next: () => void }) {
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const { dataMap } = useAppContent<'playMarket'>();
	const locale = dataMap?.locale || {};

	const onSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		void storePd({ email, phone });
		const currentParams = new URLSearchParams(window.location.search);
		if (email) {
			currentParams.set('email', email);
		}

		if (phone) {
			currentParams.set('phone', phone);
		}

		const newQueryString = currentParams.toString();
		const newUrl = `${window.location.pathname}?${newQueryString}`;

		window.history.replaceState(null, '', newUrl);

		next();
	};

	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				bottom: 0,
				right: 0,
				left: 0,
				backgroundColor: 'rgba(0,0,0,0.75)',
				zIndex: 10000,
				display: 'inline-flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexGrow: 1,
			}}
		>
			<div
				style={{
					margin: 20,
					padding: 20,
					maxWidth: 600,
					maxHeight: '80dvh',
					// minHeight: '400px',
					position: 'relative',
					overflow: 'hidden',
					backgroundColor: 'var(--color-btn-gray-bk)',
					display: 'flex',
					borderRadius: '10px',
					width: '100%',
				}}
			>
				<form action="/pwaTemplates/playMarketV2/public" onSubmit={onSubmit} style={{ flex: 1 }}>
					<div
						style={{
							width: '100%',
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<div
							style={{
								flex: 1,
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								width: '100%',
							}}
						>
							<div
								style={{
									fontWeight: 500,
									textTransform: 'uppercase',
									marginBottom: 50,
									fontSize: '2rem',
									textAlign: 'center',
								}}
							>
								{typeof locale?.contactsModal?.title !== 'undefined' ? locale?.contactsModal?.title : ''}
							</div>
							{dataMap?.additionalData?.contactsModal?.askForEmail ?
								<>
									<div className="google_input">
										<label htmlFor="phone" className="label">
											{locale?.contactsModal?.emailLabel}
										</label>
										<input
											className="input"
											type="email"
											id="email"
											name="email"
											value={email}
											required
											onChange={e => setEmail(e.target.value)}
										/>
									</div>
								</>
							:	null}
							{dataMap?.additionalData?.contactsModal?.askForPhoneNumber ?
								<>
									<div className="google_input">
										<label htmlFor="phone" className="label">
											{locale?.contactsModal?.phoneLabel}
										</label>
										<input
											className="input"
											type="tel"
											id="phone"
											name="phone"
											required
											value={phone}
											onChange={e => setPhone(e.target.value)}
										/>
									</div>
								</>
							:	null}
						</div>
						<button className="btnInstall_button__HV+hr" type="submit" style={{ border: 'none' }}>
							{locale.contactsModal?.continueButton || 'Continue'}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}

export function PlayMarketV2() {
	const [contactsModalOpened, setContactsModalOpened] = useState(false);
	const { installApp: install, progress, status, isInstalled } = useInstallerContext();
	const config = useAppContent<'playMarketSKAK'>();
	const dataMap = config.dataMap;
	const needToOpenContactsModal =
		dataMap?.additionalData?.contactsModal?.askForEmail || dataMap?.additionalData?.contactsModal?.askForPhoneNumber;

	const installApp = (forceInstall?: boolean) => {
		if (!forceInstall && needToOpenContactsModal) {
			setContactsModalOpened(true);
			return;
		}
		install();
	};

	return (
		<div id="root">
			{contactsModalOpened ?
				<ContactsModal
					next={() => {
						installApp(true);
						setContactsModalOpened(false);
					}}
				/>
			:	null}
			<div className="container themeWhite">
				<div className="wrap">
					{/*header*/}
					{!dataMap.additionalData?.tweaks?.hideHeader ?
						<div className="header_headerWrap__sm0sn">
							<div className="header_btnPrev__pPaHv">
								<div className="header_btnPrevImg__QPpZY">
									<svg height="24" viewBox="0 0 24 24" width="24">
										<path d="M0 0h24v24H0z" fill="none" />
										<path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
									</svg>
								</div>
							</div>
							<div className="header_btnPoint__9sJM4">
								<div className="header_btnPointImg__nx6po">
									<svg height="24" viewBox="0 0 24 24" width="24">
										<path d="M0 0h24v24H0z" fill="none" />
										<path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
									</svg>
								</div>
							</div>
						</div>
					:	null}

					<div className="titleIcon_titleIconWrap__CeUGO">
						<div className="titleIcon_header__vWaK4">
							{/*icon*/}
							<div
								className={`titleIcon_iconWrap__jy2dh ${progress > 0 && status !== 'success' ? 'titleIcon_load__dlhqJ' : ''}`}
							>
								<picture>
									<img alt="icon" src={withImageUrl(dataMap?.locale?.icon || '')} />
								</picture>
								{progress > 0 && status !== 'success' ?
									<svg className="titleIcon_loaderProc__f+e7E">
										<circle
											cx={36}
											cy={36}
											r={35}
											style={{
												strokeDashoffset: 215 - 215 * (progress / 100),
											}}
										/>
									</svg>
								:	null}
								{/*{installPressed ?
									progress === 0 ?
										<div className="titleIcon_loader__InyCi"></div>
									:	<svg className="titleIcon_loaderProc__f+e7E">
											<circle
												cx={36}
												cy={36}
												r={35}
												style={{
													strokeDashoffset: 215 - 215 * (progress / 100),
												}}
											/>
										</svg>

								:	null}*/}
							</div>
							<div className="titleIcon_titleInfo__GHmhK">
								<div className="titleIcon_title__BNesb">
									{dataMap?.locale?.name}{' '}
									{dataMap.locale?.isVerify ?
										<svg
											preserveAspectRatio="xMidYMid meet"
											style={{
												contentVisibility: 'visible',
												height: '36px',
												paddingBottom: '4px',
												transform: 'translate3d(0px, 0px, 0px)',
												verticalAlign: 'middle',
												width: '32px',
											}}
											viewBox="0 0 512 512"
										>
											<defs>
												<clipPath id="__lottie_element_2">
													<rect height="512" width="512" x="0" y="0" />
												</clipPath>
												<clipPath id="__lottie_element_4">
													<path d="M0,0 L512,0 L512,512 L0,512z" />
												</clipPath>
											</defs>
											<g clipPath="url(#__lottie_element_2)">
												<g
													clipPath="url(#__lottie_element_4)"
													opacity="1"
													style={{
														display: 'block',
													}}
													transform="matrix(0.6499999761581421,0,0,0.6499999761581421,-4.399993896484375,79.60000610351562)"
												>
													<g
														opacity="1"
														style={{
															display: 'block',
														}}
														transform="matrix(1,0,0,1,256,256)"
													>
														<g opacity="1" transform="matrix(0.8999999761581421,0,0,0.8999999761581421,0,0)">
															<path
																d=" M102.375,-248.5 C63,-263 32.5,-223.25 0.75,-222.625 C-31,-222 -63.75,-263 -101,-249.125 C-138.25,-235.25 -134,-184 -154.81199645996094,-159.375 C-175.62399291992188,-134.75 -229.5,-143.75 -248,-102.93800354003906 C-264.6600036621094,-66.18399810791016 -222,-31.5 -222,0.18700000643730164 C-222,33.25299835205078 -263,65.625 -248.375,102.81199645996094 C-233.75,140 -181.25,135.75 -158,156.75 C-134.75,177.75 -141,235.75 -99.75,249.125 C-58.5,262.5 -23.25,223 0.625,222.375 C24.5,221.75 62.874000549316406,261.5 101.56199645996094,249.25 C140.25,237 135.5,179.5 157.125,158 C178.75,136.5 234.75,139.5 249.5,101.875 C264.25,64.25 223,26.75 222.75,-1.25 C222.5,-29.25 262.5,-63 249.375,-101.25 C236.25,-139.5 183,-133.5 158.75,-156 C134.5,-178.5 141.75,-234 102.375,-248.5z"
																data-darkreader-inline-fill=""
																fill="rgb(68,163,221)"
																fillOpacity="1"
															/>
														</g>
													</g>
													<g
														opacity="1"
														style={{
															display: 'block',
														}}
														transform="matrix(0.9929699897766113,0,0,1.0264699459075928,253.8919219970703,247.46694946289062)"
													>
														<g opacity="1" transform="matrix(1,0,0,1,0,0)">
															<path
																d=" M-86.24800109863281,22.211999893188477 C-86.24800109863281,22.211999893188477 -37.12900161743164,69.4520034790039 -37.12900161743164,69.4520034790039 C-37.12900161743164,69.4520034790039 90.49400329589844,-52.82600021362305 90.49400329589844,-52.82600021362305"
																data-darkreader-inline-stroke=""
																fillOpacity="0"
																stroke="rgb(255,255,255)"
																strokeLinecap="round"
																strokeLinejoin="round"
																strokeOpacity="1"
																strokeWidth="50"
															/>
														</g>
													</g>
												</g>
											</g>
										</svg>
									:	null}
								</div>
								<div className="titleIcon_devName__kprOh">
									{progress > 0 && status !== 'success' ?
										<div className="titleIcon_precPer__Fvmt1">{`${progress.toFixed()}% / 7 MB`}</div>
									:	dataMap.locale?.owner}
								</div>
								<div className="titleIcon_infoAds__RZru5">
									<div className="titleIcon_extDataItem__aduY3">
										{[getLocale('playMarketSKAK:containsAds'), getLocale('playMarketSKAK:inAppPurchases')].join(' · ')}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="iconInfo_iconInfoWrap__5yKCA">
						<div className="iconInfo_scrollCon__mCXY9">
							<div className="iconInfo_item__vE2K7">
								<div className="iconInfo_icon__P5RKD">
									{dataMap.locale?.rating?.rating}
									<svg height="18" viewBox="0 0 18 18" width="18">
										<path d="M9 11.3l3.7 2.7-1.4-4.4L15 7h-4.5L9 2.5 7.5 7H3l3.7 2.6L5.3 14z" />
										<path d="M0 0h18v18H0z" fill="none" />
									</svg>
								</div>
								<div className="iconInfo_text__BRidj">
									{`${dataMap.locale?.rating?.ratingsCount} ${getLocale('playMarketSKAK:reviews')}`}
									<svg data-darkreader-inline-fill="" fill="#757575" height="24" viewBox="0 0 24 24" width="24">
										<path d="M0 0h24v24H0z" fill="none" />
										<path d="M11 17h2v-6h-2v6zm1-15a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zM11 9h2V7h-2v2z" />
									</svg>
								</div>
							</div>
							<div className="iconInfo_item__vE2K7">
								<div className="iconInfo_icon__P5RKD">
									<svg height="24" viewBox="0 0 24 24" width="24">
										<path d="M0 0h24v24H0z" fill="none" />
										<path d="M10.5 11L8.7 9.3l-1 1 2.8 3 5.8-5.9-1-1-4.8 4.8zm5.3 5.2H8.2L4.4 9.7 8.2 3h7.6l3.8 6.7-3.8 6.5zM17 1H7L2 9.7l5 8.6V23l5-2 5 2v-4.7l5-8.6L17 1z" />
									</svg>
								</div>
								<div className="iconInfo_text__BRidj">
									{getLocale('playMarketSKAK:editorsChoice')}{' '}
									<svg data-darkreader-inline-fill="" fill="#757575" height="24" viewBox="0 0 24 24" width="24">
										<path d="M0 0h24v24H0z" fill="none" />
										<path d="M11 17h2v-6h-2v6zm1-15a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zM11 9h2V7h-2v2z" />
									</svg>
								</div>
							</div>
							<div className="iconInfo_item__vE2K7">
								<div className="iconInfo_icon__P5RKD">
									<svg height="24" viewBox="0 0 24 24" width="24">
										<path d="M 0,0 H 24 V 24 H 0 Z" fill="none" />
										<path d="M 20,4 H 4 v 16 h 16 z m 0,-2 c 1.104569,0 2,0.8954305 2,2 v 16 c 0,1.104569 -0.895431,2 -2,2 H 4 C 2.8954305,22 2,21.104569 2,20 V 4 C 2,2.9 2.9,2 4,2 Z" />
										<path d="m 14.59,9.425842 1.41,1.409986 -4,4 -4,-4 L 9.41,9.425842 11,11.005828 V 6.0000007 h 2 V 11.005828 Z M 17,17.835828 H 7 v -2 h 10 z" />
									</svg>
								</div>
								<div className="iconInfo_text__BRidj">7 MB</div>
							</div>
							{/*<div className="iconInfo_item__vE2K7">
                                <div className="iconInfo_icon__P5RKD">
                                    <img alt="18+" src="/spwa-67357ee/images/age/for_app_18.webp" />
                                </div>
                                <div className="iconInfo_text__BRidj">
                                    18+{" "}
                                    <svg
                                        data-darkreader-inline-fill=""
                                        fill="#757575"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        width="24">
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path d="M11 17h2v-6h-2v6zm1-15a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zM11 9h2V7h-2v2z" />
                                    </svg>
                                </div>
                            </div>*/}
							<div className="iconInfo_item__vE2K7">
								<div className="iconInfo_icon__P5RKD">{dataMap?.locale?.rating?.downloadsCount}+</div>
								<div className="iconInfo_text__BRidj">{getLocale('playMarketSKAK:downloadsCount')}</div>
							</div>
						</div>
					</div>
					<div className="btnInstall_btnInstallWrap__7e2ql">
						<div className="btnInstall_wrap__Es3d9">
							<div className="btnInstall_button__HV+hr" onClick={() => installApp(isInstalled)}>
								{isInstalled || status === 'success' ?
									getLocale('playMarketSKAK:isInstalled')
								: status === 'installing' ?
									getLocale('playMarketSKAK:installProgress')
								:	getLocale('playMarketSKAK:installButton')}
							</div>
						</div>
					</div>
					<div className="screen_wrap__tUG-6">
						<div className="screen_scrollCon__h2j57">
							{(dataMap?.locale?.screens || []).map(screen => (
								<div className="screen_item__J+GuZ">
									<picture>
										<img
											alt="screen"
											// @ts-expect-error wrong types
											src={withImageUrl(screen?.image || screen?.url || '')}
										/>
									</picture>
								</div>
							))}
						</div>
					</div>
					<div className="blockInfo_wrap__dXLoU">
						<div className="blockInfo_titleWrap__3mSIz">
							<div className="blockInfo_title__aiyrK">{getLocale('playMarketSKAK:description')}</div>
							<div className="blockInfo_icon__m5Gvc">
								<svg height="24" viewBox="0 0 24 24" width="24">
									<path d="M0 0h24v24H0z" fill="none" />
									<path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
								</svg>
							</div>
						</div>
						<div style={{maxHeight: 'fit-content'}} className="blockInfo_body__WnTfr aboutGame_desc__wyID0">
							<RenderDescription
								description={dataMap.locale?.description || ''}
							/>
						</div>
					</div>
					<SimilarApps position="top" />
					<div className="blockInfo_wrap__dXLoU">
						<div className="blockInfo_titleWrap__3mSIz">
							<div className="blockInfo_title__aiyrK">{getLocale('playMarketSKAK:dataSafety')}</div>
							<div className="blockInfo_icon__m5Gvc">
								<svg height="24" viewBox="0 0 24 24" width="24">
									<path d="M0 0h24v24H0z" fill="none" />
									<path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
								</svg>
							</div>
						</div>
						<div className="blockInfo_body__WnTfr">
							{getLocale('playMarketSKAK:dataSafetyDescription')}
							<div className="dataSafety_wrapTI__uLHNm">
								{dataMap?.additionalData?.security?.noDataShare ?
									<div className="dataSafety_secItem__2QaHO">
										<div className="dataSafety_icon__D5jZf">
											<svg height="24" viewBox="0 0 24 24" width="24">
												<path d="M0 0h24v24H0V0z" fill="none" />
												<path d="M18 16a3 3 0 00-2 .8l-7-4.1v-1.4l7-4.1a3 3 0 10-.9-1.5L8 9.8A3 3 0 003 12a3 3 0 005 2.2l7 4.1v.7a3 3 0 103-3zm0-12c.6 0 1 .5 1 1s-.5 1-1 1-1-.5-1-1 .5-1 1-1zM6 13c-.6 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1zm12 7c-.6 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1z" />
											</svg>
										</div>
										<div className="dataSafety_info__ygg55">
											{getLocale('playMarketSKAK:noDataShared')}
											<div className="dataSafety_subInfo__GejAv">
												<span>{getLocale('playMarketSKAK:learnMore')}</span>
												{` ${getLocale('playMarketSKAK:noDataSharedLearnMore')}`}
											</div>
										</div>
									</div>
								:	null}
								{dataMap?.additionalData?.security?.noDataCollected ?
									<div className="dataSafety_secItem__2QaHO">
										<div className="dataSafety_icon__D5jZf">
											<svg height="24px" viewBox="0 -960 960 960" width="24px">
												<path d="M260-160q-91 0-155.5-63T40-377q0-78 47-139t123-78q17-72 85-137t145-65q33 0 56.5 23.5T520-716v242l64-62 56 56-160 160-160-160 56-56 64 62v-242q-76 14-118 73.5T280-520h-20q-58 0-99 41t-41 99q0 58 41 99t99 41h480q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-48-22-89.5T600-680v-93q74 35 117 103.5T760-520q69 8 114.5 59.5T920-340q0 75-52.5 127.5T740-160H260Zm220-358Z" />
											</svg>
										</div>
										<div className="dataSafety_info__ygg55">
											{getLocale('playMarketSKAK:noDataCollected')}
											<div className="dataSafety_subInfo__GejAv">
												<span>{getLocale('playMarketSKAK:learnMore')}</span>
												{` ${getLocale('playMarketSKAK:noDataCollectedLearnMore')}`}
											</div>
										</div>
									</div>
								:	null}
								<div className="dataSafety_more__iJ77w">{getLocale('playMarketSKAK:seeDetails')}</div>
							</div>
						</div>
					</div>
					<div className="blockInfo_wrap__dXLoU">
						<div className="blockInfo_titleWrap__3mSIz">
							<div className="blockInfo_title__aiyrK">{getLocale('playMarketSKAK:ratingAndReviews')}</div>
							<div className="blockInfo_icon__m5Gvc">
								<svg height="24" viewBox="0 0 24 24" width="24">
									<path d="M0 0h24v24H0z" fill="none" />
									<path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
								</svg>
							</div>
						</div>
						<div className="blockInfo_body__WnTfr">
							<div className="ratingReview_rrInfo__yH3+K">
								{getLocale('playMarketSKAK:ratingAndReviewsDescription')}{' '}
								<svg data-darkreader-inline-fill="" fill="#757575" height="24" viewBox="0 0 24 24" width="24">
									<path d="M0 0h24v24H0z" fill="none" />
									<path d="M11 17h2v-6h-2v6zm1-15a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zM11 9h2V7h-2v2z" />
								</svg>
							</div>
							<div className="ratingReview_wrapRat__MSycJ">
								<div>
									<div className="ratingReview_ratingTitle__HYP8y">{dataMap?.locale?.rating?.rating}</div>
									<div className="starRating_starList__OXpkk">
										{new Array(5).fill(null).map((_e, i) => {
											const r = parseFloat(dataMap?.locale?.rating?.rating || '5');
											if (r > i && r < i + 1) {
												return (
													<div className="starRating_starItem__4y0tg" key={i}>
														<div className="starRating_starItemNotFill__Bue+-">
															<svg height="32" viewBox="0 0 96 96" width="32">
																<path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
															</svg>
														</div>
														<div
															className="starRating_starItem__4y0tg starRating_starItemFill__35ABL"
															style={{
																clipPath: `inset(0px ${(r - i) * 100}% 0px 0px)`,
															}}
														>
															<svg height="32" viewBox="0 0 96 96" width="32">
																<path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
															</svg>
														</div>
													</div>
												);
											}

											return (
												<div
													key={i}
													className={`starRating_starItem__4y0tg ${r >= i + 1 ? 'starRating_starItemFill__35ABL' : 'starRating_starItemNotFill__Bue+-'}`}
												>
													<svg height="32" viewBox="0 0 96 96" width="32">
														<path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
													</svg>
												</div>
											);
										})}
										{/*<div className="starRating_starItem__4y0tg starRating_starItemFill__35ABL">
                                            <svg height="32" viewBox="0 0 96 96" width="32">
                                                <path
                                                    d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z"/>
                                            </svg>
                                        </div>
                                        <div className="starRating_starItem__4y0tg starRating_starItemFill__35ABL">
                                            <svg height="32" viewBox="0 0 96 96" width="32">
                                                <path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
                                            </svg>
                                        </div>
                                        <div className="starRating_starItem__4y0tg starRating_starItemFill__35ABL">
                                            <svg height="32" viewBox="0 0 96 96" width="32">
                                                <path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
                                            </svg>
                                        </div>
                                        <div className="starRating_starItem__4y0tg starRating_starItemFill__35ABL">
                                            <svg height="32" viewBox="0 0 96 96" width="32">
                                                <path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
                                            </svg>
                                        </div>
                                        <div className="starRating_starItem__4y0tg">
                                            <div className="starRating_starItemNotFill__Bue+-">
                                                <svg height="32" viewBox="0 0 96 96" width="32">
                                                    <path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
                                                </svg>
                                            </div>
                                            <div
                                                className="starRating_starItem__4y0tg starRating_starItemFill__35ABL"
                                                style={{
                                                    clipPath: "inset(0px 80% 0px 0px)",
                                                }}>
                                                <svg height="32" viewBox="0 0 96 96" width="32">
                                                    <path d="M87.6 39.1l-28.3-2.4-11.1-26.1-11 26.1-28.3 2.4 21.5 18.6L24 85.4l24.3-14.7 24.3 14.7-6.4-27.7 21.4-18.6z" />
                                                </svg>
                                            </div>
                                        </div>*/}
									</div>
									<div className="ratingReview_review__WeJla">{dataMap?.locale?.rating?.ratingsCount}</div>
								</div>
								<div className="ratingReview_wRatLine__GeJpn">
									{[
										dataMap?.locale?.rating?.ratingValues?.five,
										dataMap?.locale?.rating?.ratingValues?.four,
										dataMap?.locale?.rating?.ratingValues?.three,
										dataMap?.locale?.rating?.ratingValues?.two,
										dataMap?.locale?.rating?.ratingValues?.one,
									].map((v, i) => (
										<div className="ratingReview_lineW__xKmWH">
											<div className="ratingReview_lineNum__5FnLE">{5 - i}</div>
											<div className="ratingReview_lineBase__mV8Q0">
												<div
													className="ratingReview_lineBaseFill__DnBbq"
													style={{
														width: `${v || 0}%`,
													}}
												/>
											</div>
										</div>
									))}
								</div>
							</div>
							<Reviews />
						</div>
					</div>
					<SimilarApps position="bottom" />
					<div className="footerOther_gprp__EqEGF">
						<div className="footerOther_icon__7Uwwz">
							<svg height="24" viewBox="0 0 960.0 960.0" width="24">
								<path d="M280,760v-80L564,680q63,0 109.5,-40T720,540T673.5,440T564,400L312,400L416,504l-56,56L160,360L360,160l56,56L312,320L564,320q97,0 166.5,63T800,540T730.5,697T564,760L280,760Z" />
							</svg>
						</div>
						<div>{getLocale('playMarketSKAK:refundPolicy')}</div>
					</div>
					<div className="footerOther_price__Lx4T+">{getLocale('playMarketSKAK:includeVAT')}</div>
				</div>
				<div className="bWrap" />
			</div>
			<div className="mooterMenu_wrap__YALQk">
				<div className="mooterMenu_list__bdRSM">
					<div className="mooterMenu_item__fS3IM">
						<div className="mooterMenu_icon__LGeX7">
							<svg height="24" viewBox="0 0 24.0 24.0" width="24">
								<path d="M14.14 11.86a0.87 0.87 0 1 1 1.74 0 0.87 0.87 0 1 1-1.74 0m-1.6-2.47c-0.34 0.34-0.34 0.9 0 1.24s0.9 0.34 1.24 0 0.34-0.9 0-1.24c-0.35-0.34-0.9-0.34-1.24 0zm3.45 0.62a0.88 0.88 0 1 1 1.76 0 0.88 0.88 0 1 1-1.76 0m-1.86-1.86a0.88 0.88 0 1 1 1.76 0 0.88 0.88 0 1 1-1.76 0M9.64 7.51H8.39v1.87H6.51v1.25h1.88v1.88h1.25v-1.88h1.87V9.38H9.64z" />
								<path d="M21.29 12.41c-0.15-0.88-0.32-1.82-0.48-2.76-0.09-0.53-0.09-0.53-0.16-0.91L20.59 8.4C20.16 5.85 17.95 4 15.33 4H8.67C6.05 4 3.84 5.85 3.41 8.39L3.35 8.73C3.28 9.11 3.28 9.11 3.19 9.64c-0.16 0.94-0.33 1.88-0.49 2.81-0.58 3.4-0.7 4.07-0.7 4.21 0 1.54 1.25 2.79 2.79 2.79 0.76 0 1.46-0.27 1.98-0.79l2.88-2.84h4.71l2.88 2.85c0.51 0.51 1.21 0.79 1.97 0.79 1.54 0 2.79-1.25 2.79-2.79 0-0.15-0.12-0.82-0.71-4.26zm-2.08 5.23c-0.29 0-0.53-0.09-0.69-0.26l-3.15-3.12L15.1 14H8.9l-3.41 3.38c-0.17 0.17-0.4 0.26-0.69 0.26-0.54 0-0.98-0.44-0.98-0.98 0 0.04 1.37-7.9 1.38-7.96 0.29-1.67 1.74-2.88 3.48-2.88h6.65c1.74 0 3.19 1.21 3.47 2.88 0.01 0.06 1.39 7.99 1.39 7.95-0.01 0.55-0.44 0.99-0.98 0.99z" />
							</svg>
						</div>
						<div>{getLocale('playMarketSKAK:games')}</div>
					</div>
					<div className="mooterMenu_item__fS3IM">
						<div className="mooterMenu_icon__LGeX7">
							<svg height="24" viewBox="0 0 24.0 24.0" width="24">
								<path d="M6 13h3c1.1 0 2 0.9 2 2v3c0 1.1-0.9 2-2 2H6c-1.1 0-2-0.9-2-2v-3c0-1.1 0.9-2 2-2zm0 2v3h3v-3H6zm9-2h3c1.1 0 2 0.9 2 2v3c0 1.1-0.9 2-2 2h-3c-1.1 0-2-0.9-2-2v-3c0-1.1 0.9-2 2-2zm0 2v3h3v-3h-3zm0-11h3c1.1 0 2 0.9 2 2v3c0 1.1-0.9 2-2 2h-3c-1.1 0-2-0.9-2-2V6c0-1.1 0.9-2 2-2zm0 2v3h3V6h-3zM6 4h3c1.1 0 2 0.9 2 2v3c0 1.1-0.9 2-2 2H6c-1.1 0-2-0.9-2-2V6c0-1.1 0.9-2 2-2zm0 2v3h3V6H6z" />
							</svg>
						</div>
						<div>{getLocale('playMarketSKAK:apps')}</div>
					</div>
					<div className="mooterMenu_item__fS3IM">
						<div className="mooterMenu_icon__LGeX7">
							<svg height="24" viewBox="0 0 24 24" width="24">
								<path d="M20.5 19l-5.7-5.7a6.5 6.5 0 10-1.5 1.5l5.7 5.7 1.5-1.5zM5 9.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z" />
								<path d="M0 0h24v24H0V0z" fill="none" />
							</svg>
						</div>
						<div>{getLocale('playMarketSKAK:search')}</div>
					</div>
					<div className="mooterMenu_item__fS3IM">
						<div className="mooterMenu_icon__LGeX7">
							<svg height="24" viewBox="0 0 24 24" width="24">
								<path d="M14 2h3a3 3 0 013 3v14a3 3 0 01-3 3H4V2h10zm0 2h-3v3.6l1.5-1.2L14 7.7V4zm4 15V5c0-.5-.5-1-1-1h-1v8l-3.5-3L9 12V4H6v16h11c.5 0 1-.5 1-1z" />
							</svg>
						</div>
						<div>{getLocale('playMarketSKAK:books')}</div>
					</div>
				</div>
			</div>
		</div>
	);
}
